<template>
  <div :class="['border rounded-xl p-4', borderClass]">
    <div class="flex items-start justify-between gap-3 mb-2">
      <div class="flex items-center gap-2 min-w-0">
        <div :class="['w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0', iconBg]">
          <!-- Cab-ready icon -->
          <svg v-if="isCabReady" class="w-3.5 h-3.5" :class="iconColor" fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99z"/>
            <circle cx="7.5" cy="14.5" r="1.5"/>
            <circle cx="16.5" cy="14.5" r="1.5"/>
          </svg>
          <!-- Discount tag icon -->
          <svg v-else class="w-3.5 h-3.5" :class="iconColor" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
          </svg>
        </div>
        <h3 class="text-sm font-semibold text-slate-800 truncate">{{ notification.title }}</h3>
      </div>

      <span :class="['text-xs font-semibold px-2 py-0.5 rounded-full flex-shrink-0', badgeClass]">
        {{ notification.type }}
      </span>
    </div>

    <p class="text-sm text-slate-600 ml-8 leading-relaxed">{{ notification.message }}</p>
    <p class="text-xs text-slate-400 mt-2 ml-8">{{ formatDate(notification.createdAt) }}</p>
  </div>
</template>

<script>
export default {
  name: "NotificationCard",
  props: {
    notification: { type: Object, required: true },
  },
  computed: {
    isCabReady() {
      return (this.notification.type || '').toLowerCase().includes('cab')
    },
    borderClass() { return this.isCabReady ? 'border-blue-100' : 'border-amber-100' },
    iconBg()      { return this.isCabReady ? 'bg-blue-50'    : 'bg-amber-50' },
    iconColor()   { return this.isCabReady ? 'text-blue-600' : 'text-amber-600' },
    badgeClass()  {
      return this.isCabReady
        ? 'bg-blue-50 text-blue-700'
        : 'bg-amber-50 text-amber-700'
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
  },
};
</script>
